import React, { Component, Fragment } from 'react';
import AWS_S3 from 'aws-sdk/clients/s3';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  S3_BUCKET_NAME, 
  IMAGE_SIZE_LIMIT_BYTES, 
  VIDEO_SIZE_LIMIT_BYTES,
  MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES, 
  TOPIC_VIDEO_SIZE_LIMIT_BYTES 
} from '../../constants';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Button from '@material-ui/core/Button';
import { Tooltip, IconButton } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import ImageCropper from './Cropper';
import { VALIDATION_MESSAGES } from '../../static-content';
import { AlertJsMessage, paginationLimit } from './../../helpers.js'
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadMoreIcon from './../LoadMoreIcon';
import Compressor from 'compressorjs';
import FilePreviewButton from './../FilePreviewButton';
import { faVideo, faImage } from '@fortawesome/free-solid-svg-icons'
import zIndex from '@material-ui/core/styles/zIndex';


const acceptTypes = {
  mixed: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'video/mp4', 'video/mov'],
  video: ['video/mp4', 'video/quicktime', 'video/mov'],
  image: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'],
  audio: ['.mp3', '.m4a']
}

const fileTypes = {
  video: ['mp4', 'mov'],
  image: ['gif', 'jpeg', 'jpg', 'png'],
  audio: ['mp3','m4a']
}

/**
 * Form
 */

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  tooltipWidth: {
    maxWidth: 500,
    fontSize: 16
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export class Selection extends Component { // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    this.state = {
      type: 'upload',
      dataLoaded: false,
      selectedFile: false,
      openModal: false,
      uploadInput: {},
      showCropper: false,
      audioName: '',
      isOpenFilePreview: false,
      previewFile: {}
    };
  }

  componentWillUnmount() {
    this.props.resetFiles();
  }

 

  componentDidUpdate(prevProps) {
    const { selectedFileId, files, fieldItem, isCommunity } = this.props;
      if (selectedFileId !== prevProps.selectedFileId) {
        if (isCommunity && fieldItem !== null) {
          const {isImage, url } = fieldItem;
          if (url) {
            let preview = isImage ? 'previewImageSrc' : 'previewVideoSrc';
            let file = {
              url: url,
              category: 'COMMUNITY_ASSETS'
            }
            this.setState({
              ...this.state,
              type: 'library',
              selectedFile: file,
              fileLoaded: file,
              [preview]: url,
            })
          }
      } else if (selectedFileId !== 0) {
          this.props.
          fetchInfo(selectedFileId).then((res) => {
            let file = res[selectedFileId];
            const fileType = file.fileType.toLowerCase();
            let preview = acceptTypes.image.includes(`image/${fileType}`) ? 'previewImageSrc' : 'previewVideoSrc';
            this.setState({
              ...this.state,
              dataLoaded: true,
              selectedFile: file,
              fileLoaded: file,
              [preview]: file.url,
              type: 'library'
            })
          }).catch((err) => {
            this.setState({
              ...this.state,
              type: 'upload',
              dataLoaded: true
            })
          })
        } else {
        this.setState({
          type: 'upload',
          selectedFile: false
        })
      }
    }
  }

  componentDidMount() {
    if (!this.state.dataLoaded) {
        this.props.fetchAll({
          userId: this.props.userData.id,
          limit: paginationLimit.TEN,
          fileType: this.props.fileType,
          skip: 0,
        }).then(() => {
        const { selectedFileId, files } = this.props;
        if (selectedFileId !== 0) {
          this.props.
          fetchInfo(selectedFileId).then((res) => {
            let file = res[selectedFileId];
            const fileType = file.fileType.toLowerCase();
            let preview = acceptTypes.image.includes(`image/${fileType}`) ? 'previewImageSrc' : 'previewVideoSrc';
            this.setState({
              ...this.state,
              dataLoaded: true,
              selectedFile: file,
              fileLoaded: file,
              [preview]: file.url,
              type: 'library'
            })
          }).catch((err) => {
            this.setState({
              ...this.state,
              type: 'upload',
              dataLoaded: true
            })
          })
        } else {
          this.setState({
            ...this.state,
            type: 'upload',
            dataLoaded: true
          })
        }
      });
    }
  }

  getVideSize() {
    let size = VIDEO_SIZE_LIMIT_BYTES;
    if(this.props.isCommunity) {  
        size = TOPIC_VIDEO_SIZE_LIMIT_BYTES
    }
    return size;
  }

  resetState()  {
    this.setState({
      type: 'upload',
      previewVideoSrc: '',
      showCropper: false,
      previewImageSrc: false,
      fileLoaded: false,
      openModal: false,
      isDelete: true
    })
  }

  openFilePreview(e, file) {
    e.stopPropagation();
    this.setState({
      isOpenFilePreview: true,
      previewFile: file
    })
  }

  uploadAudio(file) {
    const s3 = new AWS_S3({
      apiVersion: '2006-03-01',
      params: { Bucket: S3_BUCKET_NAME }
    });
    const { category, addFile } = this.props;
    file = this.state.selectedAudioFile;
    const fileType = file.name.split('.').pop();
    let s3UploadObj = {
      Key: `${category}-${Date.now()}.${fileType}`,
      Body: file,
      ACL: 'public-read'
    };
    return new Promise((resolve, rej) => {
      if (file) {
        s3.upload(s3UploadObj, (err, ec2Data) => {
          if (err) {
            AlertJsMessage('There was an error uploading your photo: ', err.message);
            this.props.hideLoader();
            rej('');
          }

          addFile({
            userId: this.props.userData._id,
            url:  `https://${process.env.REACT_APP_ASSET_URL}/${ec2Data.Key}`,
            category: category,
            fileType: fileType,
            name: file.name
          }).then((newFile) => {
            this.props.hideLoader();
            resolve(newFile);
          });
        });
      } else {
        rej('No File');
      }
    });
  }

  handleAudioFileChange({ target }) {
    const file = target.files[0];
    if (file) {
      if (file.type.includes('audio')) {
        if (file.size > VIDEO_SIZE_LIMIT_BYTES) {
          AlertJsMessage(`Audio is too large. The audio you are trying to upload has a size of ${(file.size / 1000000).toFixed(2)} MB. The limit for an audio upload is ${VIDEO_SIZE_LIMIT_BYTES / 1000000} MB. Please upload another audio.`);
          target.value = '';
          this.setState({
            ...this.state,
            previewImageSrc: '',
            previewVideoSrc: '',
            fileLoaded: false
          })
          return;
        } else {
          this.setState({
            ...this.state,
            type: 'upload',
            uploadAudioInput: target,
            selectedAudioFile: file,
            fileLoaded: true,
            audioName: file.name
          })
        }
      }
    } else {
      AlertJsMessage("No file selected.");
    }
  }

  handleFileChange({ target }, fileType) {
    const file = target.files[0];
    if (file) {
      if (acceptTypes.image.includes(file.type) && (fileType === 'image' || fileType === 'mixed')) {
        if (file.size > IMAGE_SIZE_LIMIT_BYTES) {
          AlertJsMessage(VALIDATION_MESSAGES.IMAGE_LIMIT_EXCEEDS(file.size));
          target.value = '';
          this.setState({
            previewImageSrc: '',
            previewVideoSrc: '',
            fileLoaded: false
          })
        } else {
          const _that = this;
          new Compressor(file, {
            quality: 0.5,
            success(result) {
              var reader = new FileReader();
              reader.readAsDataURL(result);
              reader.onload = function () {
                _that.setState({
                  type: 'upload',
                  uploadInput: target,
                  previewImageSrc: reader.result,
                  previewVideoSrc: '',
                  fileLoaded: true,
                  openModal: false
                })
              };
              
            }
          })
        }
      }
      if (file.type === 'video/mp4' || file.type === 'video/quicktime' || file.type === 'video/mov') {
        const videoSize = this.getVideSize();

        if (file.size > videoSize) {
          if (this.props.isCommunity) {
            AlertJsMessage(VALIDATION_MESSAGES.TOPIC_VIDEO_LIMIT_EXCEEDS(file.size));
          } else {
            AlertJsMessage(VALIDATION_MESSAGES.VIDEO_LIMIT_EXCEEDS(file.size));
          }
          target.value = '';
          this.setState({
            previewImageSrc: '',
            previewVideoSrc: '',
            fileLoaded: false
          })
          return;
        } else {
          this.setState({
            type: 'upload',
            uploadInput: target,
            previewVideoSrc: window.URL.createObjectURL(file),
            previewImageSrc: '',
            fileLoaded: true,
            openModal: false
          })
        }

      }
    } else {
      AlertJsMessage("No file selected.");
    }
  }
  submitNewFile(type = '') {
    this.setState({
      isUploading: true
    });
    this.props.showLoader();
    const s3 = new AWS_S3({
      apiVersion: '2006-03-01',
      params: { Bucket: S3_BUCKET_NAME }
    });
    const { category, addFile } = this.props;
    if (this.state.selectedAudioFile && type) {
      return this.uploadAudio()
    }
    let file;
    file = this.state.uploadInput.files && this.state.uploadInput.files[0];

    const fileType = file && file.name.split('.').pop();
    let s3UploadObj = {
      Key: `${category}-${Date.now()}.${fileType}`,
      Body: file,
      ACL: 'public-read'
    };
    if (acceptTypes.image.includes(file.type)) {
      const base64Data = new Buffer.from(this.state.previewImageSrc.replace(/^data:image\/\w+;base64,/, ""), 'base64');
      const type = this.state.previewImageSrc.split(';')[0].split('/')[1];
      s3UploadObj = {
        ...s3UploadObj,
        Body: base64Data,
        ContentEncoding: 'base64',
        ContentType: `image/${type}`
      };
    }
    return new Promise((resolve, rej) => {
      if (file) {
        let isTranscoding;
        if (file.size > MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES || file.type === 'video/quicktime' || file.type === 'video/mov') {
          isTranscoding = true;
        }
        s3.upload(s3UploadObj, (err, ec2Data) => {
          if (err) {
            AlertJsMessage('There was an error uploading your photo: ', err.message);
            this.props.hideLoader();
            rej('');
          }
          if(this.props.isCommunity) { 
            let file = {}
            if (acceptTypes.image.includes(fileType)) {
              file.imageDimension = this.state.dimensions;
            }
            file.fileType = fileType;
            file.url = `https://${process.env.REACT_APP_ASSET_URL}/${ec2Data.Key}`;
            file.isTranscoding = isTranscoding;
            file.isUpload = true;
            resolve(file);
          } else {
            addFile({
              userId: this.props.userData._id,
              url:  `https://${process.env.REACT_APP_ASSET_URL}/${ec2Data.Key}`,
              category: category,
              fileType: fileType,
              isTranscoding: isTranscoding,
              name: file.name
            }).then((newFile) => {
              this.props.hideLoader();
              resolve(newFile);
            });
          }
        });
      } else {
        rej('No File');
      }
    });

  }

  selectFromLibrary(file) {
    let { fileType } = file;
    fileType = fileType.toLowerCase();
    this.setState({
      selectedFile: file,
      type: 'library',
      previewImageSrc: fileTypes.image.includes(fileType) ? file.url : '',
      previewVideoSrc: fileTypes.video.includes(fileType) ? file.url : '',
      fileLoaded: true,
      openModal: false
    })
  }

  getCroppedImage = (croppedImage, isCancelled) => {
    if (isCancelled) {
      this.setState({
        type: 'upload',
        previewVideoSrc: '',
        showCropper: false,
        previewImageSrc: false,
        fileLoaded: false,
        openModal: true
      })
    } else {
      this.setState({
        previewImageSrc: croppedImage,
        type: 'upload',
        previewVideoSrc: '',
        fileLoaded: true,
        openModal: false,
        showCropper: false
      })
    }
  }

  clearImage = () => {
    this.setState({
      previewImageSrc: false,
      previewVideoSrc: false,
      fileLoaded: false,
      openModal: false
    })
  }

  render() {
    const { dataLoaded, previewImageSrc, previewVideoSrc, selectedFile, showCropper } = this.state;
    const { fileType, user, isShowHelpIcon = false, classes, isBrand, imageCategory, deleteAssetAction, isDeleteAsset, isBodyMatrix, isSelectFromLibrary, isMobile } = this.props;
    let uploadText = 'Upload';
    if (isSelectFromLibrary) {
      uploadText = 'Select';
    }
    if (dataLoaded) {
      const filesData = this.props.files.data
        .filter((file) => {
          const type = file.fileType.toLowerCase();
          return (
            (acceptTypes[fileType].includes('image/' + type) ||
              acceptTypes[fileType].includes('video/' + type)) &&
            file.userId.includes(user._id)
          )
        });
      
      const key = 'createdAt';
      const files = [...new Map(filesData.map(item =>[item[key], item])).values()];
      
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {
            this.state.fileLoaded && this.props.fileType !== 'audio' && (previewVideoSrc || previewImageSrc) ? (
              <div style={{
                textAlign: 'center',
                height: isBodyMatrix ? 60 : 150,
                width: isBodyMatrix ? 130 : 300,
                backgroundColor: COLORS.lightGrey,
                margin: isBodyMatrix && '5px'
              }}>
                {
                  this.state.fileLoaded ? (
                    <div style={{
                      textAlign: 'center',
                      height: isBodyMatrix? 65 : 150,
                      width: isBodyMatrix ? 130: 300,
                      border: '2px solid ' + COLORS.grey,
                      backgroundColor: COLORS.lightGrey
                    }}>
                      
                      {previewVideoSrc ? (
                        <video loop muted autoPlay src={previewVideoSrc} style={{ height: '100%', maxWidth: '295px', width: isBodyMatrix && '126px' }} playsInline />

                      ) : null}
                      {previewImageSrc ? (
                        <img
                          style={{
                            height: '100%',
                            width: 'auto',
                            maxWidth: '100%'
                          }}
                          src={previewImageSrc}
                          alt={"Selected"}
                        />
                      ) : null}
                    </div>
                  ) : null
                }
              </div>
            ) : (
                <div style={{
                  textAlign: 'center',
                  height: 40,
                  width: 55,
                  backgroundColor: COLORS.lightGrey,
                  border: '2px solid ' + COLORS.grey
                }}>
                </div>
              )
          }

          <div style={{ padding: 10, marginLeft: isBodyMatrix && '-8px'  }}>

            {fileType !== 'audio' ? (
            <Fragment>
              { isDeleteAsset && this.state.fileLoaded &&
                <Button
                    style={{marginRight: 10,
                       backgroundColor: '#ff0000',
                       color: '#ffffff'
                    }}
                    variant="contained"
                    onClick={() => deleteAssetAction() }>
                    <ButtonContent
                      text={fileType === 'image' ?  `Delete Image` : fileType === 'video' ? `Delete Video` : `Delete Image or Video`}
                    />
                  </Button>
              }
              <Button
                color='secondary'
                variant="contained"
                onClick={() => this.setState({ ...this.state, openModal: true })}>
                { isMobile ?
                 <ButtonContent
                    text={''}
                    icon="upload"
                  />
                :
                <ButtonContent
                  text={fileType === 'image' ?  `${uploadText} Photo` : fileType === 'video' ? `${uploadText} New Video` : `${uploadText} New Photo or Video`}
                  icon="upload"
                />
                 }
              </Button>
            </Fragment>
            
            ) : ''}
            {this.props.fileType === 'audio' ? (
              <span><Button
                variant="contained"
                component="label"
                size="small"
                style={{ backgroundColor: COLORS.orange, color: COLORS.white, marginLeft: "10px" }}
              >
                <AddIcon />
                  Upload Audio
                  <input
                  type="file"
                  onChange={(e) => this.handleAudioFileChange(e)}
                  accept={acceptTypes['audio'].toString()}
                  style={{ display: "none" }}
                />
              </Button>
                <span style={{ marginLeft: "10px" }}>{this.state.audioName}</span></span>) : ''}

            {isShowHelpIcon &&
              <Tooltip classes={{ tooltip: classes.tooltipWidth }}
                title=
                {'Your profile image will be the image of your first exercise in your workout if you don’t upload a photo or video'}>
                <IconButton>
                  <HelpIcon />
                </IconButton>
              </Tooltip>
            }
          </div>
          { this.state.isOpenFilePreview && 
          <FilePreviewButton 
            isOpen= {this.state.isOpenFilePreview} 
            item = {this.state.previewFile } 
            handleClose = {
              () => {
                this.setState({
                  isOpenFilePreview: false
                })
              }
            }
          />
        } 
          <Dialog
            style={{}}
            open={this.state.openModal}
            onClose={() => this.setState({ ...this.state, openModal: false })}
          >
            <DialogTitle id="customized-dialog-title" onClose={() => this.setState({ openModal: false })}>
              {this.props.fileType !== 'audio' ? (fileType === 'image') ? `${uploadText} Photo` : fileType === 'video' ? `${uploadText} New Video` : `${uploadText} New Photo or Video` : ''}
            </DialogTitle>
            <DialogContent>
              <div style={{ width: 400, height: 400,   overflow: 'auto' }}>
                { !isSelectFromLibrary &&
                  <Button
                    variant="contained"
                    component="label"
                    size="small"
                    style={{ backgroundColor: COLORS.orange, color: COLORS.white }}
                  >
                    <AddIcon />
                    Upload New File
                    <input
                      type="file"
                      onChange={(e) => this.handleFileChange(e, fileType)}
                      accept={acceptTypes[fileType].toString()}
                      style={{ display: "none" }}
                    />
                  </Button>
                }
                <div id="scrollableFileModal" style={{ height: isSelectFromLibrary ? 370 : 300, overflow: "auto" }}>
                  <InfiniteScroll
                          dataLength={files.length} //This is important field to render the next data
                          next={() =>  {
                            this.props.fetchAll({
                              userId: this.props.userData.id,
                              limit: paginationLimit.TEN,
                              skip: files.length,
                              fileType: this.props.fileType,
                            })
                          }}
                          hasMore={this.props.files.isLoadMore}
                          scrollableTarget="scrollableFileModal"
                          loader={<LoadMoreIcon/>}
                      >
                    {files.length ?
                      <GridList style={{ margin: '15px 0 10px 0' }} cellHeight={150}>
                        {files.map(file => {
                          return (
                            <GridListTile
                              onClick={() => this.selectFromLibrary(file)}
                              key={file._id} style={{'position': 'relative'}}>
                                
                              <FontAwesomeIcon icon="eye" title={'Preview'}
                                onClick={(e) => this.openFilePreview(e, file)}
                                style={{ 
                                    marginRight: 5, 
                                    color: COLORS.orange, 
                                    position: 'absolute', 
                                    bottom: 5, 
                                    right:20,
                                    cursor: 'pointer',
                                    zIndex: 9999
                                  }}
                                />
                                <FontAwesomeIcon icon={
                                  acceptTypes[fileType].includes('image/' + file.fileType) ? faImage : faVideo
                                } title={file.name}
                                  style={{ 
                                    marginRight: 5, 
                                    color: COLORS.orange, 
                                    position: 'absolute', 
                                    bottom: 5, 
                                    right:0, 
                                    cursor: 'pointer',
                                    zIndex: 9999
                                  }}
                                />
                                {
                                  acceptTypes[fileType].includes('image/' + file.fileType) ? (
                                    <img src={file.url} alt={file.name} />
                                  ) : (
                                    <img src={file.screenShotUrl} alt={file.name} />
                                    )
                                }
                            

                              {
                                selectedFile._id === file._id ? (
                                  <GridListTileBar
                                    title={'Selected'}
                                    titlePosition="top"
                                  />
                                ) : null
                              }

                            </GridListTile>
                          )
                        })}
                      </GridList> :
                      (
                        <div style={{ textAlign: 'center', margin: 10 }}>
                          <span>No photos/videos available in Library. Please click on Upload New File and start uploading.</span>
                        </div>
                      )
                    }
                </InfiniteScroll>
                </div>
              </div>
            </DialogContent>

          </Dialog>
          {showCropper
            && <ImageCropper imageCategory={imageCategory}
              showCropper={showCropper} isBrand={isBrand} fileUrl={previewImageSrc}
              getCroppedImage={this.getCroppedImage} />}
        </div>
      );
    }
    return null;
  }
}

export default withStyles(styles)(Selection);



// WEBPACK FOOTER //
// ./src/components/files/Selection.js